import { render, staticRenderFns } from "./MCPConsent.vue?vue&type=template&id=a1b160ea&scoped=true"
import script from "./MCPConsent.vue?vue&type=script&lang=js"
export * from "./MCPConsent.vue?vue&type=script&lang=js"
import style0 from "./MCPConsent.vue?vue&type=style&index=0&id=a1b160ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b160ea",
  null
  
)

export default component.exports